import { BaseForm } from '@app/components/common/forms/BaseForm/BaseForm';
import { Input } from '@app/components/common/inputs/Input/Input';
import { InputNumber } from '@app/components/common/inputs/InputNumber/InputNumber';
import { Button } from '@app/components/common/buttons/Button/Button';
import { Skeleton } from '@app/components/common/Skeleton/Skeleton';
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useMounted } from '@app/hooks/useMounted';
import { getMailerConfig, MailerSettingData, updateMailerConfig } from '@app/api/settings.api';
import { Col, Row } from 'antd';

const MailerSetting: React.FC = () => {
  const [form] = BaseForm.useForm();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const { isMounted } = useMounted();

  const fetch = useCallback(() => {
    setLoading(true);
    getMailerConfig()
      .then((data) => {
        form.setFieldsValue(data);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [isMounted]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  const handleSubmit = (values: MailerSettingData) => {
    setLoading(true);
    updateMailerConfig(values).finally(() => {
      setLoading(false);
    });
  };

  return (
    <Skeleton loading={loading}>
      <BaseForm form={form} layout="vertical" name="mail-setting" onFinish={handleSubmit}>
        <Row gutter={[24, 16]}>
          <Col span={12} lg={{ span: 6 }}>
            <BaseForm.Item name="host" label="SMTP" rules={[{ required: true, message: t('common.requiredField') }]}>
              <Input />
            </BaseForm.Item>
          </Col>
          <Col span={12} lg={{ span: 6 }}>
            <BaseForm.Item name="port" label="Port" rules={[{ required: true, message: t('common.requiredField') }]}>
              <InputNumber style={{ width: '100%' }} />
            </BaseForm.Item>
          </Col>
          <Col span={12} lg={{ span: 6 }}>
            <BaseForm.Item
              name="username"
              label="Username"
              rules={[{ required: true, message: t('common.requiredField') }]}
            >
              <Input />
            </BaseForm.Item>
          </Col>
          <Col span={12} lg={{ span: 6 }}>
            <BaseForm.Item
              name="password"
              label="Password"
              rules={[{ required: true, message: t('common.requiredField') }]}
            >
              <Input />
            </BaseForm.Item>
          </Col>
        </Row>
        <Button type="primary" style={{ marginTop: '15px', float: 'right' }} htmlType="submit">
          Save
        </Button>
      </BaseForm>
    </Skeleton>
  );
};

export default MailerSetting;
